import type { editions as en } from '@/i18n/locales/en/editions';
import type { Translation } from '@/i18n/types';

export const editions: Translation<typeof en> = {
  fit: {
    sections: {
      home: 'Ana sayfa',
      insights: 'İçgörüler',
      programs: 'Programlar',
      content: 'İçerik',
    },
    items: {
      overview: 'Genel Bakış',
      departments: 'Departmanlar',
      users: 'Kullanıcılar',
      vitality: 'Canlılık',
      participation: 'Katılım',
      pilots: 'Pilotlar',
      challenges: 'Meydan Okumalar',
      communications: 'İletişim',
      documents: 'Belgeler',
      reports: 'Raporlar',
      settings: 'Ayarlar',
    },
  },
  soccer: {
    sections: {
      home: 'Ana sayfa',
      insights: 'İçgörüler',
      programs: 'Programlar',
    },
    items: {
      overview: 'Genel Bakış',
      departments: 'Takımlar',
      users: 'Oyuncular',
      vitality: 'Canlılık',
      participation: 'Katılım',
      pilots: 'Pilotlar',
      challenges: 'Meydan Okumalar',
    },
  },
};
